<script lang="ts">
    import MobileScreen from "@app/components/MobileScreen.svelte";
    import {
        dictionary,
        updateDictionary,
    } from "@app/services/currentDictionary.service";
    import { getRecommendedDictionaries } from "@app/services/dictionariesRecommendationService";
    import {
        COMMON__Change_dictionary,
        COMMON__Dictionary,
        COMMON__popular,
        COMMON__recentlyUsedLanguages,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { getLanguageImmediately } from "@app/services/languages.service";
    import type { DictionaryLanguageType } from "../ChangeDictionary.store";
    import {
        hideChangeDictionaryWidget,
        showChangeLanguageWidget,
    } from "../ChangeDictionary.store";
    import ChangeDictionaryWidgetSingleDictionary from "./ChangeDictionaryWidgetSingleDictionary.svelte";

    function toggleDictionaryLanguages() {
        updateDictionary({ l1: $dictionary.l2, l2: $dictionary.l1 });
    }

    function changeLanguage(type: DictionaryLanguageType) {
        showChangeLanguageWidget(type);
    }

    function changeDictionary(event: Event) {
        const button = event.currentTarget as HTMLButtonElement;
        const l1Code = button.dataset["l1"];
        const l2Code = button.dataset["l2"];
        const l1 = $getLanguageImmediately(l1Code);
        const l2 = $getLanguageImmediately(l2Code);
        updateDictionary({ l1, l2 });
        hideChangeDictionaryWidget();
    }

    let recommendedDictionaries = getRecommendedDictionaries();
    const navbarButtonClass = `px-3 py-2 h-10 inline-flex items-center justify-center rounded text-sm leading-5 text-white bg-primary-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-300 ease-in-out`;
</script>

<MobileScreen
    message={COMMON__Change_dictionary}
    onBackClick={hideChangeDictionaryWidget}
>
    <div class="w-full bg-gray-100 py-2 flex px-1">
        <div class="flex-1 text-center px-1 overflow-hidden">
            <button
                on:click={() => changeLanguage("source")}
                class="{navbarButtonClass} w-full"
                aria-label="Change source language"
                data-element="source-language"
                data-languagecode={$dictionary.l1.code}
            >
                <span class="truncate">{$dictionary.l1.name}</span>
                <span class="icon-arrow-down" />
            </button>
        </div>
        <div class="px-1">
            <button
                class={navbarButtonClass}
                on:click={toggleDictionaryLanguages}
                aria-label="Flip languages"
                data-element="flip-languages"
            >
                <span class="icon-swap-horizontal" />
            </button>
        </div>
        <div class="flex-1 text-center px-1 overflow-hidden">
            <button
                on:click={() => changeLanguage("target")}
                class="{navbarButtonClass} w-full"
                aria-label="Change target language"
                data-element="target-language"
                data-languagecode={$dictionary.l2.code}
            >
                <span class="truncate">{$dictionary.l2.name}</span>
                <span class="icon-arrow-down" />
            </button>
        </div>
        <div class="px-1">
            <button
                on:click={hideChangeDictionaryWidget}
                class={navbarButtonClass}
                aria-label="OK"
            >
                <span
                    ><svg
                        height="24"
                        width="24"
                        viewBox="0 0 48 48"
                        class="fillCurrentColor"
                        fill="currentColor"
                        ><path
                            d="M18.9 36.75 6.65 24.5l3.3-3.3 8.95 9L38 11.1l3.3 3.25Z"
                        /></svg
                    ></span
                >
            </button>
        </div>
    </div>

    <div class="bg-gray-50 text-lg">
        <ul>
            {#if recommendedDictionaries.recentlyUsed && recommendedDictionaries.recentlyUsed.length > 0}
                <li class="uppercase text-gray-700 text-sm p-2">
                    {getMessage(COMMON__recentlyUsedLanguages)}
                </li>
                {#each recommendedDictionaries.recentlyUsed as dict}
                    <li class="p-1">
                        <ChangeDictionaryWidgetSingleDictionary
                            {dict}
                            {changeDictionary}
                        />
                    </li>
                {/each}
            {/if}
            {#if recommendedDictionaries.recommended && recommendedDictionaries.recommended.length > 0}
                <li class="uppercase text-gray-700 text-sm p-2">
                    {getMessage(COMMON__popular)}
                </li>
                {#each recommendedDictionaries.recommended as dict}
                    <li class="p-1">
                        <ChangeDictionaryWidgetSingleDictionary
                            {dict}
                            {changeDictionary}
                        />
                    </li>
                {/each}
            {/if}
        </ul>
    </div>
</MobileScreen>
